import TRTC from 'trtc-js-sdk'
import { APPID } from '@/constant'


export class RtcClient {
  SDKAppID = APPID;
  userId = '';
  userSig = '';
  client = null;
  localStream = null;
  remoteStream = null;
  cbPool = {};
  roomId = null;

  constructor() {
    this.SDKAppID = APPID
  }

  createClient(userId, userSig) {
    this.userId = userId;
    this.userSig = userSig;

    this.client = TRTC.createClient({
      mode: 'rtc',
      sdkAppId: this.SDKAppID,
      userId,
      userSig
    })
    TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.WARN);

    this.addRtcListener()
  }

  addRtcListener() {
    this.client.on('stream-added', event => {
      console.log('------------------stream-added-----------------------');
      console.log(event);
      const remoteStream = this.remoteStream = event.stream;

      this.remoteStream.on('player-state-changed', (event) => {
        console.log('------------------player-state-changed-----------------------');
        console.log(event.state);
        if (event.state === 'PLAYING') {
          const cbList = this.cbPool['remote-stream-playing'] || [];
          cbList.forEach(cb => {
            cb(event.state)
          });
        }
      });

      console.log(remoteStream);
      const cbList = this.cbPool['stream-added'] || [];
      cbList.forEach(cb => {
        cb(remoteStream)
      });
    });

    this.client.on('peer-leave', event => {
      const userId = event.userId;
      const cbList = this.cbPool['peer-leave'] || [];
      cbList.forEach(cb => {
        cb(userId)
      });
    });
  }

  removeRtcListener() {
    this.client?.off('*');
  }

  async join({ roomId }) {
    this.roomId = roomId
    return this.client.join({ roomId });
  }

  async leave() {
    this.cbPool = {};

    this.localStream?.stop();
    this.localStream?.close();
    this?.unpublish();
    this.remoteStream?.off('*');

    // this.removeRtcListener();

    this.roomId = null;
    this.client?.leave();
    this.localStream = null;
    this.remoteStream = null;
  }

  async publish() {
    if (!this.roomId) {
      return
    }
    this.localStream = TRTC.createStream({ userId: this.userId, audio: true, video: true });
    console.log('------------------localStream-----------------------');
    console.log(this.localStream);
    if (this.localStream) {
      await this.localStream.initialize()
      .then(() => {
        this.client.publish(this.localStream)
      })
    }
  }

  async unpublish() {
    if (this.localStream) {
      await this.client?.unpublish(this.localStream)
    }
  }

  on(type, cb) {
    const cbList = this.cbPool[type] || []
    if (cbList.indexOf(cb) === -1) {
      cbList.push(cb)
    }
    this.cbPool[type] = cbList
  }

  off(type, cb) {
    const cbList = this.cbPool[type] || []

    const index = cbList.indexOf(cb)
    if (index > -1) {
      cbList.splice(index, 1)
    }

    this.cbPool[type] = cbList
  }
}